"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKFLOW_STATUS = {
    ACTIVE: 'Active',
    INACTIVE: 'InActive',
};
exports.EXECUTION_STATUS = {
    SUCCESS: 'Success',
    FAILED: 'Error',
};
exports.STEP_EXECUTION_STATUS = {
    SUCCESS: 'Success',
    FAILED: 'Failed',
};
exports.NODE_TYPES = {
    TRIGGER: 'trigger',
    RESOURCE: 'resource',
    ACTION: 'action',
    FILTER: 'filter',
    NOTIFICATION: 'notify',
    USER_APPROVAL: 'approval',
    LOGICAl: 'logical',
    VISUALIZATION: 'visualization',
    AUGMENTATION: 'augmentation',
    DELAY: 'delay',
    CUSTOM: 'custom',
    REPORT: 'report',
    MONITORING: 'monitoring',
};
//# sourceMappingURL=constants.js.map